/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import * as React from 'react';
import { MerchantTrackingDto } from '../models/merchant-tracking-dto';
import { CurrencyValue } from '../models/currency-value';
import { transformImgUrl } from '../helpers';
import i18n from '../getText';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/ar';

interface Params {
  merchant: MerchantTrackingDto,
  totalCost: CurrencyValue,
  number: string
}

export class OrderSubHeader extends React.Component<Params, any> {

  private moneyFormatter = null;

  constructor(props) {
    super(props);
    this.moneyFormatter = new Intl.NumberFormat('GB', {
      minimumFractionDigits: 2
    });
  }


  render() {
    return (
      <div>
        <div className="store_info">
          <div className="store_info-details">
            <p className="store_info-order_id">
              {i18n.pgettext('OrderSubHeader', 'Order')}&nbsp;#<span dir="ltr">{this.props.number}</span>
            </p>
            <p className="store_info-store_name">{this.props.merchant.name}</p>
          </div>
          <div className="store_info-logo_wrap">
            <img src={transformImgUrl(this.props.merchant.imageUrl)}
                 srcSet={`${transformImgUrl(this.props.merchant.imageUrl, 2)} 2x, ${transformImgUrl(this.props.merchant.imageUrl, 3)} 3x`}
                 alt={i18n.pgettext('OrderSubHeader', 'Store Logo')}
                 className="store_info-logo"/>
          </div>
        </div>
        <div className="price_info">
          <div
            className="price_info-price">
            {i18n.pgettext('OrderSubHeader', 'Price')}&nbsp;<span
            dir="ltr">{this.moneyFormatter.format(this.props.totalCost.value)} {this.props.totalCost.currency || 'SAR'}</span>
          </div>
          <div className="price_info-type">
            <img src="assets/icCashGrey.png"
                 srcSet="assets/icCashGrey@2x.png 2x, assets/icCashGrey@3x.png 3x"
                 alt="cash icon"/>&nbsp;{i18n.pgettext('OrderSubHeader', 'Cash')}
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/app/components/OrderSubHeader.tsx